import Vue from 'vue'
import _ from 'lodash'

export function byId(state) {
  return (id) => {
    return _.find(state.results, {id: id})
  }
}

export function savePayload(state) {
  return (endpoint) => {
    const payload = JSON.parse(JSON.stringify({
      endpoint: endpoint,
      data: state.edit
    }))
    if (state.edit.id) {
      payload.id = state.edit.id
    }
    return payload
  }
}

export function resetState(state) {
  Object.keys(state).forEach(key => {
    state[key] = null
  })
}

export function resetResults(state) {
  state.results = []
}

export function hydrateEdit(state, data) {
  if (data) {
    Object.keys(state.edit).forEach(key => {
      if (data.hasOwnProperty(key)) {
        state.edit[key] = data[key]
      }
    })
  }
}

export function addResult(state, entity) {
  if (!state.results) {
    state.results = []
  }
  state.results.push(entity)
}

export function updateResult(state, entity) {
  let index = -1

  if (!state.results || state.results.length === 0) {
    return
  }

  if (state.results[0].hasOwnProperty('_id')) {
    // Elasticsearch result
    index = _.findIndex(state.results, {_id: entity.id})
    const result = JSON.parse(JSON.stringify(state.results[index]))

    Object.keys(entity).forEach(key => {
      result._source[key] = entity[key]
    })

    Vue.set(state.results, index, result) // needed to trigger reactivity on arrays
  }

  // ptrac-api result
  index = _.findIndex(state.results, {id: entity.id})
  Vue.set(state.results, index, entity) // needed to trigger reactivity on arrays
}

export function deleteResult(state, id) {
  if (!Array.isArray(state.results) || state.results.length === 0) {
    console.warn("state.results is not an array or is empty. Unable to delete result.")
    return
  }

  if (state.results[0].hasOwnProperty('_id')) {
    // Elasticsearch result
    state.results = _.filter(state.results, (esResult) => esResult._id !== id)
  } else {
    // ptrac-api result
    state.results = _.filter(state.results, (entity) => entity.id !== id)
  }
}

export function crudifyMutations(mutations) {
  mutations.add = addResult
  mutations.update = updateResult
  mutations.delete = deleteResult
}
